import { render, staticRenderFns } from "./FormQuestions.vue?vue&type=template&id=b7a49628&scoped=true&"
import script from "./FormQuestions.vue?vue&type=script&lang=js&"
export * from "./FormQuestions.vue?vue&type=script&lang=js&"
import style0 from "./FormQuestions.vue?vue&type=style&index=0&id=b7a49628&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a49628",
  null
  
)

export default component.exports